<div class="incoming-call-container" *ngIf="iframeActive; else callEnded">
    <div class="call-stage">
        <div class="ticket__incomingchat__container__actions" *ngIf="roomUrl">
            <iframe
                [src]="roomUrl"
                allow="camera; microphone; fullscreen; speaker; display-capture"
            >
            </iframe>
        </div>
    </div>

    <div class="call-controls">
        <div class="ticket__incomingchat__container__actions--middle-size">
            <p class="call-hint">Quando hai finito, premi il pulsante rosso.</p>
            <button
                mat-raised-button
                color="warn"
                class="full-width-button"
                (click)="terminateCall()"
            >
                <mat-icon>call_end</mat-icon>
                <span class="call-action-label">Termina</span>
            </button>
        </div>
    </div>
</div>

<ng-template #callEnded>
    <div class="call-ended-message-container fo-card-lg" *ngIf="!ticketExpired">
        <span class="call-ended-badge">
            <mat-icon class="call-ended-icon">call_end</mat-icon>
        </span>
        <div class="call-ended-message">La chiamata è stata terminata.</div>
        <p class="call-ended-hint">Puoi chiudere questa pagina.</p>
    </div>
    <div class="call-ended-message-container fo-card-lg" *ngIf="ticketExpired">
        <span class="call-ended-badge call-ended-badge--warning">
            <mat-icon class="call-ended-icon">error_outline</mat-icon>
        </span>
        <div class="call-ended-message">
            Il link per accedere alla chiamata non è più valido.
        </div>
        <p class="call-ended-hint">Richiedi un nuovo link per partecipare.</p>
    </div>
</ng-template>
